import { dayAdd, dayToLocalDate, momentPassed, zoneToday } from 'src/app/infrastructure/functions/zone-day.function';

// Gesloten lidmaatschap: het eindmoment (UTC, exclusief) is voorbij — zelfde regel als de backend
// (MembershipAccessRules.Closed). Het record is dan alleen-lezen (Edit disabled, reden periodClosed) tot
// "Toegang herstellen" (DomainUser/ProjectMember start) een nieuwe periode opent.
export function membershipClosed(endDate: string | null | undefined): boolean {
    return momentPassed(endDate);
}

// Datumregels voor handmatige periodes (toegangsperiode van een lidmaatschap in DomainUserEdit en
// ProjectMemberEdit, DateClose van een project) — plan A "FunctionMember-periodes", gespiegeld aan de
// backend (MembershipAccessRules, ProjectController.Update). Alles in kalenderdagen ('yyyy-MM-dd') van
// de zone van het domain/project (zie zone-day / ZoneClock), niet van de browser:
// - start: alleen te wijzigen zolang die nog in de toekomst ligt, en niet vóór vandaag;
// - einde (laatste dag mét toegang): op zijn vroegst gisteren ("nu beëindigen"); eigen lidmaatschap op
//   zijn vroegst vandaag (direct beëindigen van jezelf weigert de backend: SelfEndNotAllowed).
// De backend controleert hetzelfde; dit zorgt alleen dat de datepicker geen ongeldige datum aanbiedt.
// Let op: [min] markeert een BESTAANDE eerdere waarde als ongeldig (en blokkeert dan het hele formulier),
// dus min alleen zetten als de huidige waarde zelf nog wijzigbaar is.
export interface IMembershipAccessDates {
    startReadonly: boolean;
    startMin: Date | null;
    endMin: Date | null;
}

export function membershipAccessDates_get(
    startDay: string | null | undefined,
    endDay: string | null | undefined,
    timeZoneId: string | null | undefined,
    ownMembership = false,
): IMembershipAccessDates {
    const __today = zoneToday(timeZoneId);
    const __yesterday = dayAdd(__today, -1);

    const __startStarted = !!startDay && startDay <= __today;
    const __endPassed = !!endDay && endDay < __yesterday;

    return {
        startReadonly: __startStarted,
        startMin: __startStarted ? null : dayToLocalDate(__today),
        endMin: __endPassed ? null : dayToLocalDate(ownMembership ? __today : __yesterday),
    };
}

// DateClose van een project (eerste dag zonder werk) in het formulier = geplande sluiting, op zijn vroegst
// morgen; per vandaag sluiten gaat via de lock-knop op ProjectDetails (met bevestiging). Een al gesloten
// project is niet te bewerken — dan geen min, anders is de huidige (verstreken) waarde ongeldig.
export function projectDateCloseMin_get(dateCloseDay: string | null | undefined, timeZoneId: string | null | undefined): Date | null {
    return projectIsClosed(dateCloseDay, timeZoneId) ? null : dayToLocalDate(dayAdd(zoneToday(timeZoneId), 1));
}

export function projectIsClosed(dateCloseDay: string | null | undefined, timeZoneId: string | null | undefined): boolean {
    return !!dateCloseDay && dateCloseDay <= zoneToday(timeZoneId);
}
